module.exports = __webpack_public_path__ + "static/data_sales_icon-17e532a75bbc1323167548c8e52e0f11.svg";